import React from "react";
import PlanetteYellow2 from "../../Decorations/PlanetteYellow2/PlanetteYellow2";
import YellowMoon from "../../Decorations/YellowMoon";
import OrangeMoon from "../../Decorations/OrangeMoon";

export interface IHighlightProductCardDecorationBaseProps {
  variant?: "star" | "fox";
}

const HighlightProductCardDecorationBase = ({
  variant,
}: IHighlightProductCardDecorationBaseProps) => {
  if (variant === "star") {
    return (
      <>
        <OrangeMoon
          styles={{
            position: "absolute",
            top: 0,
            left: 0,
            transform: "translate(-10%, -44%)",
            zIndex: 1,
            mobile: {
              scale: "0.78",
              transform: "translate(-19%, -41%)",
            },
          }}
        />

        <PlanetteYellow2
          styles={{
            position: "absolute",
            bottom: 0,
            left: 0,
            transform: "translate(40%, 27%)",
            zIndex: 1,
            mobile: {
              transform: "translate(-27%, -9%)",
            },
          }}
        />
      </>
    );
  }
  if (variant === "fox") {
    return (
      <>
        <YellowMoon
          styles={{
            position: "absolute",
            bottom: 0,
            right: 0,
            transform: "translate(36%, 28%)",
            zIndex: 1,
            mobile: {
              scale: "0.87",
              transform: "translate(15%, 33%)",
            },
          }}
        />
      </>
    );
  }
  return null;
};

export default HighlightProductCardDecorationBase;
